import * as React from "react";
import {ProductsEnum, resourcesHelper} from "@falcon/services";

const { FAQ_CAR_URL, FAQ_HOME_URL } = resourcesHelper;

interface IProps {
    product: string,
    type: string,
}

export class DirectDebitInformationModal extends React.Component<IProps> {

    public static readonly DDI_TYPE_PAYMENT:string = "payment"
    public static readonly DDI_TYPE_REFUND:string = "refund"

    public render() {
        const faqUrl = this.props.product === ProductsEnum.HOME
            ? FAQ_HOME_URL
            : FAQ_CAR_URL
        return (
            <div className="inner-content mb-3 p-0">
                {this.props.type === DirectDebitInformationModal.DDI_TYPE_PAYMENT &&  <React.Fragment><p>
                        <span className="font-weight-bold">Please note that changes to your Direct Debit details can take up to 10 working days to take effect.</span> That
                        means if your next instalment date falls in this window, there's a small chance we'll miss it.
                        If this happens you will have to pay the instalment by card.</p>
                    <p>
                        You must pay from your own current account (not a savings or business account).
                        Your payments will be collected under <span
                        className="font-weight-bold">{resourcesHelper.THEME} Insurance</span> name.
                    </p>
                </React.Fragment>
                }
                {this.props.type === DirectDebitInformationModal.DDI_TYPE_REFUND &&  <p>
                    <span className="font-weight-bold">We need to set up a Direct Debit so we can refund to your bank account
                        (we won’t use it to take your monthly instalments). When your refund arrives, you can cancel the Direct Debit with your bank.</span>
                    </p>
                }
                <p>
                    Need help? <a className="d-inline font-weight-bold text-decoration-underline" target="_blank"
                                  href={faqUrl}>Our FAQs</a> have the answers for Direct Debit queries.
                </p>
            </div>

        );
    }

}
